import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-wallet3-icon',
  templateUrl: './shopping-wallet3.component.html'
})
export class ShoppingWallet3Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
